import { render } from "./payroll-view.vue?vue&type=template&id=5e078060"
import script from "./payroll-view.vue?vue&type=script&lang=js"
export * from "./payroll-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__